import Grid from "@mui/material/Grid2";
import { useTranslation } from "react-i18next";
import { MacroOptionalMetricsTable } from "../MacroOptionalMetricsTable/MacroOptionalMetricsTable";
import { MacroResults, Years } from "orval/generated/models";
import { OptionalMetricsTableResultsType } from "../MacroOptionalMetricsTable/Types";
import getResultsOverviewTableColumns from "../MacroOptionalMetricsTable/HelperFunctions/getResultsOverviewTableColumns";
import getResultsOverviewTableData from "../MacroOptionalMetricsTable/HelperFunctions/getResultsOverviewTableData";
import getResultsOverviewSalesTableData from "../MacroOptionalMetricsTable/HelperFunctions/getResultsOverviewSalesTableData";

export type CarbonEmissionsBySectionProps = {
  scenarioResults: MacroResults | null;
  scenarioYears: Years;
  type: OptionalMetricsTableResultsType;
};

export function CarbonEmissionsBySection({
  scenarioResults,
  scenarioYears,
  type,
}: CarbonEmissionsBySectionProps) {
  const { t } = useTranslation("macro");
  const tempColumns = getResultsOverviewTableColumns(
    type,
    scenarioYears.base_year?.toString() || "",
    scenarioYears.target_year?.toString() || "",
  );

  return (
    <>
      <Grid container rowSpacing={3} columnSpacing={3}>
        <Grid
          size={{
            md: 12,
            lg: type !== OptionalMetricsTableResultsType.BY_PILLAR ? 6 : 12,
          }}
        >
          <MacroOptionalMetricsTable
            columns={tempColumns}
            data={scenarioResults}
            dataExtractionFunction={getResultsOverviewTableData}
            type={type}
            displaySubtitle={true}
            title={t(
              "resultsSection.carbonEmissionOverview.tableHeaders.absoluteEmission",
            )}
            showFilterDropdown
          />
        </Grid>
        {type !== OptionalMetricsTableResultsType.BY_PILLAR && (
          <Grid size={{ md: 12, lg: 6 }}>
            <MacroOptionalMetricsTable
              columns={tempColumns}
              data={scenarioResults}
              dataExtractionFunction={getResultsOverviewSalesTableData}
              type={type}
              subtitle={t(
                "resultsSection.carbonEmissionOverview.filters.units.sales_volume",
              )}
              displaySubtitle={true}
              title={t(
                "resultsSection.carbonEmissionOverview.tableHeaders.salesVolume",
              )}
              showFilterDropdown={false}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}
